import { Link } from "gatsby"
import React from "react"
import { slide as Menu } from 'react-burger-menu'
import Logo from './vectors/logo'
import BWLogo from './vectors/bw_logo'
import './layout.scss'
import CallToAction from './cta'


const Header = () => {

  
  return (
    
    <header>
<Link to='/'>
 <Logo className='logo'/>
 </Link>

    
    <nav className='lg-nav'>
      <ul>
        <li><Link to='/our_services' activeClassName='active'>Our Services</Link></li>
        <li><Link to='/our_vehicles' activeClassName='active'>Our Vehicles</Link></li>
        <li><Link to='/retail_installations' activeClassName='active'>Retail Installations</Link></li>
        <li><Link to='/about_us' activeClassName='active'>About Us</Link></li>
        <li><Link to='/contact' activeClassName='active'>Contact Us</Link></li>
        <li><CallToAction to='/quote_request' text='Request Quote' /></li>
  
      </ul>
    </nav>
    
      <Menu right width={'80%'}>
      <Link to='/'>Home</Link>
      <Link to='/our_services'>Our Services</Link>
       <Link to='/our_vehicles'>Our Vehicles</Link>
       <Link to='/retail_installations'>Retail Installations</Link>
       <Link to='/about_us'>About Us</Link>
       <Link to='/contact'>Contact Us</Link>
       <Link className='.cta' to='/quote_request'>Request Quote</Link>
       <BWLogo className='bwlogo'/>

      </Menu>
  

    </header>

  
  
    )
  
}
 


export default Header
